import React, { useEffect, useMemo } from "react";
import { Autocomplete, Skeleton, TextField, Checkbox } from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import { useDistributorsContext } from "../Contexts/distributorsContext";
import { useFulfillmentStatusContext } from "../Contexts/fulfillmentStatusContext";

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;

export default function RegionMultiSelection() {
    const { distributors, isReady: areDistributorsReady } = useDistributorsContext();
    const {
        selectedDivisions,
        selectedRegions,
        setSelectedRegions,
    } = useFulfillmentStatusContext();

    const regionOptions = useMemo(() => {
        if (!distributors) {
            return [];
        }

        const selectedDivisionSet = new Set(selectedDivisions || []);

        return [...new Set(distributors
            .filter((distributor) => selectedDivisionSet.size === 0 || selectedDivisionSet.has(distributor.division))
            .map((distributor) => distributor.region?.trim())
            .filter((region) => !!region))]
            .sort((left, right) => left.localeCompare(right));
    }, [distributors, selectedDivisions]);

    useEffect(() => {
        if (!selectedRegions || selectedRegions.length === 0) {
            return;
        }

        const allowedRegions = new Set(regionOptions);
        const validSelectedRegions = selectedRegions.filter((region) => allowedRegions.has(region));

        if (validSelectedRegions.length !== selectedRegions.length) {
            setSelectedRegions(validSelectedRegions);
        }
    }, [regionOptions, selectedRegions, setSelectedRegions]);

    if (!areDistributorsReady) {
        return (
            <div>
                <Skeleton variant="rectangular" width={250} height={50} />
            </div>
        );
    }

    return (
        <Autocomplete
            multiple
            limitTags={1}
            disablePortal
            id="combo-box-region"
            options={regionOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option}>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option}
                </li>
            )}
            sx={{ width: 250 }}
            renderInput={(params) => (
                <TextField {...params} label="Select Regions" />
            )}
            value={selectedRegions || []}
            onChange={(event, value) => {
                setSelectedRegions(value);
            }}
        />
    );
}
